import { createFileRoute } from '@tanstack/react-router'
import { StaffActivityLog } from '../../../../components/StaffActivityLog'

export const Route = createFileRoute('/platform/desa/$desaId/log-aktivitas')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffActivityLog desaId={desaId} />
  },
})
